export enum UserActionTypes {
    ACTION_LOGIN = 'ACTION_LOGIN',
    ACTION_LOGOUT = 'ACTION_LOGOUT'
  }
  